/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FineKinneyHazardDamageDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: FineKinneyHazardDamageDefinitionDto.source;
    label?: string;
    value?: number;
}

export namespace FineKinneyHazardDamageDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
